// @flow

import React from "react";
import "./styles.css";
import LinearProgress from "@material-ui/core/LinearProgress";

type PropsType = { children?: React.Node, message: ?string };

export const SplashScreen = ({ children, message }: PropsType): React$Element<any> => (
    <div className={ "splash" }>
        <div className={ "splash_container" }>
            {children}
            <h3 className={ "splash_message" }>
                {message || null}
            </h3>
            <LinearProgress/>
        </div>
    </div>
);

